import { render, staticRenderFns } from "./VirHomePart2.vue?vue&type=template&id=234c833f&scoped=true&"
import script from "./VirHomePart2.vue?vue&type=script&lang=js&"
export * from "./VirHomePart2.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart2.vue?vue&type=style&index=0&id=234c833f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c833f",
  null
  
)

export default component.exports